import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { useI18n } from '@elo-kit/components/i18n/i18n'

import { BLOCK_MENU_HIGHLIGHT_IDS } from '@elo-kit/constants/block.constants'
import { DEFAULT_PAGE_NUMBER } from '../constants/constants'

export const Pagination = React.memo((props) => {
  const I18n = useI18n()
  const {
    locales = {
      docIsNotVisibleTitle: I18n.t('react.shared.pdf_errors.title'),
      docIsNotVisibleContent: I18n.t('react.shared.pdf_errors.content'),
      docIsNotVisibleBtnContent: I18n.t('react.shared.pdf_errors.button'),
      renderPaginationInfo: (localeProps) => I18n.t('react.shared.num_of', localeProps),
    },
    classes,
    NumberFieldComponent,
    previewMode,
    numPages,
    pageNumber,
    loading,
    paginatorValue,
    handlePagination,
  } = props

  const paginationMsg = locales.renderPaginationInfo({
    now: pageNumber,
    max: numPages || DEFAULT_PAGE_NUMBER,
  })

  const isPaginationInactive = loading || numPages === DEFAULT_PAGE_NUMBER
  const isPrevPageInactive = pageNumber === DEFAULT_PAGE_NUMBER
  const isNextPageInactive = pageNumber === numPages

  return (
    <div className={classNames('pagination-container', classes.paginationContainer, { disabled: loading })}>
      <span
        className={classNames('action-btn', classes.actionButton, {
          disabled: isPaginationInactive || isPrevPageInactive,
        })}
        onClick={() => handlePagination(pageNumber - 1)}
        {...(previewMode && {
          'data-highlighter-item': BLOCK_MENU_HIGHLIGHT_IDS.filePdf.blockButtonStyle,
          'data-highlighter-selector': '.action-btn, .zoom-container',
          'data-highlighter-parent': '.toolbar-container-items',
        })}
      >
        <i className='fas fa-chevron-circle-left' />
      </span>
      <span className={classNames('pagination-info', classes.paginationInfo)}>
        <NumberFieldComponent
          value={paginatorValue}
          onChange={(value) => handlePagination(value)}
          min={1}
          max={numPages}
          withArrows={false}
          disabled={isPaginationInactive}
        />
        <span
          className={classNames('pagination-msg', classes.paginationInfoMsg)}
          dangerouslySetInnerHTML={{ __html: paginationMsg }}
        />
      </span>
      <span
        className={classNames('action-btn', classes.actionButton, {
          disabled: isPaginationInactive || isNextPageInactive,
        })}
        onClick={() => handlePagination(pageNumber + 1)}
        {...(previewMode && {
          'data-highlighter-item': BLOCK_MENU_HIGHLIGHT_IDS.filePdf.blockButtonStyle,
          'data-highlighter-selector': '.action-button',
          'data-highlighter-parent': '.toolbar-container-items',
        })}
      >
        <i className='fas fa-chevron-circle-right' />
      </span>
    </div>
  )
})

Pagination.propTypes = {
  classes: PropTypes.object,
  locales: PropTypes.shape({
    docIsNotVisibleTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    docIsNotVisibleContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    docIsNotVisibleBtnContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    renderPaginationInfo: PropTypes.func,
  }),
  previewMode: PropTypes.bool,
  loading: PropTypes.bool,
  pageNumber: PropTypes.number,
  numPages: PropTypes.number,
  NumberFieldComponent: PropTypes.any,
  paginatorValue: PropTypes.number,
  handlePagination: PropTypes.func,
}

Pagination.defaultProps = {
  classes: {},
  previewMode: false,
  loading: false,
  pageNumber: 1,
  numPages: 1,
  NumberFieldComponent: 'input',
  paginatorValue: 1,
}
